import { render } from "react-dom";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
  useLocation,
} from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import './index.css';
import 'animate.css';
import reportWebVitals from './reportWebVitals';

import { SESSION, TEAM, CAMPAIGN_STATUS, WAS_SHOW_MODAL_CAMPAIGN, SHOW_MODAL_NEW_CAMPAIGN_EVENT } from './constants';
import LocalStorage from './services/local-storage';

import Login from './pages/auth/Login';
import ForgotPassword from './pages/auth/ForgotPassword';
import IndividualChallenge from './pages/individual-challenge/IndividualChallenge';
import SupportMaterials from './pages/support-materials/SupportMaterials';
import TeamChallenge from './pages/team-challenge/TeamChallenge';
import Question from './pages/team-challenge/Question';
import RoundQuestion from './pages/individual-challenge/RoundQuestion';
import Settings from './pages/settings/Settings';
import Achievements from './pages/achievements/Achievements';
import EventBusService from './services/EventBusService'
import { NEW_CAMPAIGN_EVENT } from './constants';
import CampaignService from './services/campaign-service';
import ModalCampaignFinishedStatus from './components/modal-campaign-finished/modal-campaign-finished';
import ModalCampaignStatus from "./components/modal-campaign/modal-campaign";

const rootElement = document.getElementById("root");

const PrivateRoute = () => {
  const session = LocalStorage.get(SESSION);

  useEffect(() => {
    return () => { }
  }, [])

  return session ? <Outlet /> : <Navigate to="/auth/login" />;
}


function ScrollToTop() {
  const { pathname } = useLocation();

  const [currentCampaign, setCurrentCampaign] = useState(null);

  const [modalCapaignFinished, setModalCapaignFinished] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);

    const getCampaign = async () => {
      const campaign = LocalStorage.get(CAMPAIGN_STATUS);
      const team = LocalStorage.get(TEAM)
      const session = LocalStorage.get(SESSION)
      const response = await CampaignService.getCampaign(team.area._id);

      if(campaign && !response) {
        const statusCampaign = await CampaignService.getCampaignResult(team.area._id, session._id);
        setCurrentCampaign(statusCampaign)
      }

      if(!response) {
        LocalStorage.set(CAMPAIGN_STATUS, false);
        LocalStorage.set(WAS_SHOW_MODAL_CAMPAIGN, false);
      } else {
        LocalStorage.set(CAMPAIGN_STATUS, response);
      }

      EventBusService.dispatch(NEW_CAMPAIGN_EVENT, { campaign: response });
    }

    const session = LocalStorage.get(SESSION);
    
    if(session) {
      getCampaign();
    }

  }, [pathname]);

  return currentCampaign ? <ModalCampaignFinishedStatus isOpen={modalCapaignFinished} data={currentCampaign} onClose={() => setModalCapaignFinished(false)} />: null;
}

function HandleModalCampaign() {
  const [showModalCampaign, setModalCampaign] = useState(false);
  const [campaign, setCampaign] = useState(LocalStorage.get(CAMPAIGN_STATUS));

  const handleCloseModalCampaign = () => {
    LocalStorage.set(WAS_SHOW_MODAL_CAMPAIGN, true);
    setModalCampaign(false);
  }

  const handleCampaignStatus = useCallback((event) => setCampaign(event.detail?.campaign), [])

  useEffect(() => {
    EventBusService.on(NEW_CAMPAIGN_EVENT, handleCampaignStatus)

    return () => {
        EventBusService.remove(NEW_CAMPAIGN_EVENT, handleCampaignStatus)
    }
  }, [handleCampaignStatus])

  const handleModalCampaign = useCallback(() => setModalCampaign(true), [])

  useEffect(() => {
    EventBusService.on(SHOW_MODAL_NEW_CAMPAIGN_EVENT, handleModalCampaign)

    return () => {
        EventBusService.remove(SHOW_MODAL_NEW_CAMPAIGN_EVENT, handleModalCampaign)
    }
  }, [handleModalCampaign])
 
  useEffect(() => {
    const wasShow = LocalStorage.get(WAS_SHOW_MODAL_CAMPAIGN);
    if(campaign && !wasShow) {
        setModalCampaign(true);
    }
  }, [campaign])


  return <ModalCampaignStatus isOpen={showModalCampaign} campaign={campaign} onClose={handleCloseModalCampaign}/>;
}

render(
  <BrowserRouter>
    <HandleModalCampaign />
    <ScrollToTop />    
    <Routes>
      <Route path="/auth" >
        <Route path="login" element={<Login />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
      </Route>
      <Route path="/" element={<PrivateRoute/>} >
        <Route path="" element={<IndividualChallenge />} />
        <Route path="individual-challenge/round" element={<RoundQuestion />} />
        <Route path="support-materials" element={<SupportMaterials />} />
        <Route path="team-challenge" element={<TeamChallenge />} />
        <Route path="team-challenge/question" element={<Question />} />
        <Route path="settings" element={<Settings />} />
        <Route path="achievements" element={<Achievements />} />
      </Route>
    </Routes>
  </BrowserRouter>,
  rootElement
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();